import { Typography } from "@circleco/compass/components/Typography";

export const ParticipantListTitle = ({ title }: { title: string }) => (
  <div className="my-2">
    <Typography variant="label-xs" color="tertiary">
      {title}
    </Typography>
  </div>
);
